<template>
  <div>
    <div
      v-if="project"
      class="px-4 sm:px-6 md:px-8 mb-8 flex items-center justify-between flex-wrap sm:flex-no-wrap"
    >
      <div class="max-w-7xl">
        <h1 class="text-2xl font-semibold text-gray-900">
          {{ project.title }}
        </h1>
      </div>
      <div class="flex-shrink-0">
        <span class="inline-flex rounded-md shadow-sm">
          <button
            @click="openAttachUserModal"
            type="button"
            class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
          >
            Ajouter un membre
          </button>
        </span>
      </div>
    </div>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mt-4" v-if="project">
      <div class="max-w-7xl mx-auto pb-12">
        <div>
          <div class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
            <div class="bg-white overflow-hidden shadow rounded-lg">
              <div class="px-4 py-5 sm:p-6">
                <dl>
                  <dt
                    class="text-sm leading-5 font-medium text-gray-500 truncate"
                  >
                    Date
                  </dt>
                  <dd
                    class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                  >
                    {{ project.date | date_dmy }}
                  </dd>
                </dl>
              </div>
            </div>
            <div class="bg-white overflow-hidden shadow rounded-lg">
              <div class="px-4 py-5 sm:p-6">
                <dl>
                  <dt
                    class="text-sm leading-5 font-medium text-gray-500 truncate"
                  >
                    Durée
                  </dt>
                  <dd
                    class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                  >
                    {{ totalDuration }}
                  </dd>
                </dl>
              </div>
            </div>
            <div class="bg-white overflow-hidden shadow rounded-lg">
              <div class="px-4 py-5 sm:p-6">
                <dl>
                  <dt
                    class="text-sm leading-5 font-medium text-gray-500 truncate"
                  >
                    Clips
                  </dt>
                  <dd
                    class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                  >
                    {{ project.clips.length }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col">
        <div
          class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
        >
          <div class="bg-white shadow overflow-hidden sm:rounded-md">
            <div
              class="p-6 grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-6"
              v-if="hasClips"
            >
              <clip-preview
                v-for="clip in project.clips"
                :key="clip.id"
                :clip="clip"
                @open-detail="openDetail"
              ></clip-preview>
            </div>
            <div class="p-6" v-if="!hasClips">
              <p>Pas encore de clips</p>
            </div>
            <div
              v-if="hasClips"
              class="bg-white px-4 py-3 flex items-center justify-end border-t border-gray-200 sm:px-6"
            >
              <button
                @click="downloadAllClips"
                type="button"
                class="rounded-md border border-gray-300 text-sm px-6 py-2 bg-white leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:outline-none focus:shadow-outline-indigo"
              >
                Télécharger tous les clips
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <attach-user-modal
      v-if="project"
      :open="openAttachUser"
      @close="closeAttachUserModal"
      :project="project"
    ></attach-user-modal>
    <view-clip-modal
      :open="openClip !== null"
      @close="closeViewClipModal"
      :clip="openClip"
    ></view-clip-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ClipPreview from "@/components/Clips/ClipPreview";
import ViewClipModal from "@/components/Clips/ViewClipModal";
import AttachUserModal from "@/components/Projects/AttachUserModal";

export default {
    components: {
        ClipPreview,
        AttachUserModal,
        ViewClipModal
    },
    data() {
        return {
            openAttachUser: false,
            openClip: null
        };
    },
    computed: {
        ...mapState("project", ["projects"]),
        project() {
            return this.projects.filter(project => {
                return project.public_id === this.$route.params.id;
            })[0];
        },
        hasClips() {
            return this.project ? this.project.clips.length > 0 : false;
        },
        totalDurationInSeconds() {
            return this.project.clips
                .reduce((total, clip) => clip.duration + total, 0)
                .toFixed(0);
        },
        totalDuration() {
            const minutes = Math.floor(this.totalDurationInSeconds / 60);
            const seconds = this.totalDurationInSeconds - minutes * 60;
            return `${minutes}m ${seconds}s`;
        }
    },
    methods: {
        openDetail(clip) {
            this.openClip = clip;
        },
        closeViewClipModal() {
            this.openClip = null;
        },
        openAttachUserModal() {
            this.openAttachUser = true;
        },
        closeAttachUserModal() {
            this.openAttachUser = false;
        },
        downloadAllClips() {
            this.project.clips.forEach(clip => {
                window.open(clip.download_url, "_blank");
            });
        }
    }
};
</script>